import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { NotBlankGenericFieldValidator } from '../../../../../validations/not-blank-generic-field-validator'
// import { DateTextFieldValidator } from '../../../validations/date-text-field.validator'
import { DataEntryStep1 } from '../../../../models/data-entry-step1'
// import { ValidatedRadioButtonModel } from '../../../validations/validated-radio-button-group.component'
import { EnrollmentGateway } from '../../../../gateways/enrollment-gateway'
import { PortalGlobals } from '../../../../../portalglobals'
import { EnrollmentViewModel } from '../../../../models/enrollment-view-model'
import { StateGateway } from '../../../../../common/gateways/state-gateway'
import { ValidatedSelectOptionModel as State } from '../../../../../validations/validated-dropdown.component'
import { ValidatedRadioButtonModel } from '../../../../../validations/validated-radio-button-group.component'
import { ValidatedSelectOptionModel } from '../../../../../validations/validated-dropdown.component'
import { NumericTextFieldValidator } from '../../../../../validations/numeric-text-field-validator'
import { LengthTextFieldValidator } from '../../../../../validations/length-text-field-validator'
import { PreEnrollmentCallLogDetails } from '../../../../models/PreEnrollmentCallLogDetails'
import { CurrentUserGateway } from '../../../../../common/gateways/current-user-gateway'
import { EnrollmentHeader } from '../../../../models/EnrollmentHeader'
import { EnrollmentField, EnrollmentFieldCodes } from '../../../../models/enrollment-field'
import { ExternalEnrollmentFieldCodes } from '../../../../models/ExternalEnrollmentFieldCodes'
import { BeneficiaryInfo } from '../../../../models/enrollments'
import { PlanList } from '../../../../models/plan-list'
import { AddressDB } from '../../../../../user-management/models/address'
import { DatePipe } from '@angular/common'
import * as moment from 'moment'
import { PhoneNumberInputMask } from '../../../../../common/input-masks/phone-number.input-mask'
import { LicenseApptGateway } from '../../../../../user-management/gateways/license-appt-gateway'
import { SubmitEnrollmentDataResponse } from './../../../../models/submit-enrollment-data-response'
import * as _ from 'lodash'
import { EnrollmentCacheData } from '../../../../models/EnrollmentCacheData'
import { callStartGateway } from '../../../../../call-start/gateways/call-start-gateway'
import { RaceEthnicityComponent } from '../../../common/race-ethnicity.component'
import { ValidatedDateTextField } from '../../../../../validations/validated-date-text-field.component'
import { RelationshipToEnrollee } from '../../../../models/relationshipToEnrollee'
import { UtilsService } from '../../../common/utils-service'
import { AuthService } from '../../../../../auth/auth-service'

@Component({
    selector: 'PhoneEnrollmentExtStep1',
    templateUrl: 'phone-enrollment-step1.component.html',
    styleUrls: ['../phone-enrollment.component.scss'],
    providers: [DatePipe]
})
export class PhoneEnrollmentExtStep1Component implements OnInit {
    private _raceEthnicityComponent: RaceEthnicityComponent
    public rblrecord: ValidatedRadioButtonModel[] = []
    public rblRep: ValidatedRadioButtonModel[] = []
    public rblBenfe: ValidatedRadioButtonModel[] = []
    public rblBenfereply: ValidatedRadioButtonModel[] = []

    public rblAuthorizedRep: ValidatedRadioButtonModel[] = []
    public ddllMailCopy: ValidatedSelectOptionModel[] = []
    rblRelation: ValidatedSelectOptionModel[] = []

    validatedDate = new ValidatedDateTextField()
    notBlankValidator = new NotBlankGenericFieldValidator()
    numericTextFieldValidator = new NumericTextFieldValidator()
    lengthValidator = new LengthTextFieldValidator(10)
    phoneNumberInputMask = new PhoneNumberInputMask()
    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef
    @Input() states: State[] = [] as State[]
    @Input() authrepstates: State[] = [] as State[]
    dataEntryStep1 = {} as DataEntryStep1
    enrollment: EnrollmentViewModel = {} as EnrollmentViewModel
    rblrecordyes: boolean
    rblrecordno: boolean
    rblrepyes: boolean
    rblrepno: boolean
    rblbenfeyes: boolean
    rblbenfeno: boolean
    rblbenfereplyyes: boolean
    rblbenfereplyno: boolean
    hasError: boolean
    ErrorMessages: any[]
    public agentUserName: string
    isValidAgent: boolean
    CUID: string
    AgentID: string
    isQtip: boolean
    roleCode: string
    isEnroller: boolean
    IsPhoneEnrollmentAccess: boolean
    public sub: any
    calllogid: number
    callLog = {} as PreEnrollmentCallLogDetails
    currentOrgid: string
    enrollercurrentOrgid: string
    agentOrgId: number
    insuranceComapny: string
    checkPlanyear: boolean = false
    enrollmentHeader: EnrollmentHeader = {} as EnrollmentHeader
    SEPReasonCodeList: any[]
    benefitaryModel: BeneficiaryInfo = {} as BeneficiaryInfo
    residentialAddress: AddressDB = {} as AddressDB
    mailingAddress: AddressDB = {} as AddressDB
    showQtip: boolean
    enrollmentCacheData: EnrollmentCacheData = {} as EnrollmentCacheData
    ShowCurrentYearScript: boolean = false
    planList: PlanList[] = [] as PlanList[]
    public optionrbPlan: ValidatedRadioButtonModel[] = []
    public loading: boolean = false
    planvalue: string
    UserState: string
    UILangEng: boolean
    IsSameAddress: boolean
    CheckGoodStanding: boolean = false
    mailingstates: State[] = [] as State[]
    genderOptions: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[]
    titleOptions: ValidatedSelectOptionModel[] = [] as ValidatedSelectOptionModel[]
    titleOption: string = ''
    genderOption: string = ''
    planstatename: string
    rblbenfInfo: boolean
    spnyouheshe: string
    spnyourhisher: string
    spnyouhimher: string
    spnYouheshe: string
    spnIsBeneficiary2: string
    spnIsBeneficiary: string
    spnIsAre: string
    spnYourMediBeneficiary: string
    spnDoDoes: string
    spnIsAreCapt: string
    spnIsBeneficiaryYour: string
    spnIsQualify: string
    spnYouThey: string
    spnYourTheir: string
    spnHasHave: string
    spnIsReside: string
    spnYourBeneficiaryNew: string
    AgentFullName: string
    spnIsBeneficiaryYou: string
    spndodoes: string
    spnyoubenef: string
    spnYoutheenrollee: string
    spnnameofMedicare: string
    selectedyear: number
    agentFullname: string
    spnyouthey: string
    disabled: boolean
    visibleFrom2025: boolean
    isMyAplgy: boolean = false
    isVisibleIndiv: boolean = true

    constructor(
        public _global: PortalGlobals,
        private router: Router,
        private _licenseAppGateway: LicenseApptGateway,
        private utils: UtilsService,
        private _stateGateway: StateGateway,
        private route: ActivatedRoute,
        private _callStartGateway: callStartGateway,
        private _currentUserGateway: CurrentUserGateway,
        private _enrollementGateway: EnrollmentGateway,
        private _authService: AuthService,
        private pipe: DatePipe
    ) {
        this._raceEthnicityComponent = new RaceEthnicityComponent(this._enrollementGateway)
        this.rblrecord.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblRep.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblBenfe.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblBenfereply.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })

        this.rblAuthorizedRep.push({ value: 'No', htmlLabel: 'No' }, { value: 'Yes', htmlLabel: 'Yes' })
        this.ddllMailCopy.push({ value: 'No', text: 'No' }, { value: 'Yes', text: 'Yes' })
        this.rblRelation.push(
            { value: 'Aunt', text: 'Aunt' },
            { value: 'Brother', text: 'Brother' },
            { value: 'Caretaker', text: 'Caretaker' },
            { value: 'Case Worker', text: 'Case Worker' },
            { value: 'Companion', text: 'Companion' },
            { value: 'Cousin', text: 'Cousin' },
            { value: 'Daughter', text: 'Daughter' },
            { value: 'Daughter In Law', text: 'Daughter In Law' },
            { value: 'Father', text: 'Father' },
            { value: 'Father In Law', text: 'Father In Law' },
            { value: 'Friend', text: 'Friend' },
            { value: 'Grand Daughter', text: 'Grand Daughter' },
            { value: 'Grand Son', text: 'Grand Son' },
            { value: 'Home Provider', text: 'Home Provider' },
            { value: 'Hospice', text: 'Hospice' },
            { value: 'Husband', text: 'Husband' },
            { value: 'Mother In Law', text: 'Mother In Law' },
            { value: 'Mother', text: 'Mother' },
            { value: 'Nephew', text: 'Nephew' },
            { value: 'Niece', text: 'Niece' },
            { value: 'Power of Attorney', text: 'Power of Attorney' },
            { value: 'Program Coordinator', text: 'Program Coordinator' },
            { value: 'Other', text: 'Other' },
            { value: 'Residential Support', text: 'Residential Support' },
            { value: 'Son In Law', text: 'Son In Law' },
            { value: 'Sister', text: 'Sister' },
            { value: 'Son', text: 'Son' },
            { value: 'Social Worker', text: 'Social Worker' },
            { value: 'Step Daughter', text: 'Step Daughter' },
            { value: 'Step Son', text: 'Step Son' },
            { value: 'Wife', text: 'Wife' },
            { value: 'Spouse', text: 'Spouse' }
        )
        this._stateGateway.getAllStates().subscribe((states: State[]) => (this.authrepstates = states))
        this.rblrecordyes = true
        this.rblrecordno = true

        this.rblrepyes = true
        this.rblrepno = true

        this.rblbenfereplyyes = true
        this.rblbenfereplyno = true

        this.rblbenfeyes = true
        this.rblbenfeno = true

        this.ErrorMessages = [] as any[]
        this.isQtip = false
        this.enrollment.AUTHREPIND = 'No'
        this.isEnroller = false
        this.SEPReasonCodeList = [] as any[]
        this.IsSameAddress = true
        this.rblbenfInfo = true
        this.disabled = false
    }

    CheckPhoneEnrllAccess() {
        if (this._global.currentUser.insuranceCompanyId !== undefined && this._global.currentUser.roleId !== undefined) {
            const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
            this._enrollementGateway
                .GetPhoneEnrollmentAcccessCheck(parseInt(this._global.currentUser.orgId), this._global.currentUser.roleId.toString())
                .subscribe(
                    (model: any) => {
                        if (model === undefined || model === null || model === false) {
                            this.router.navigate(['/' + insCo + '/enrollment/enrollmentPage'])
                        }
                    },
                    (error) => {
                        this.router.navigate(['/' + insCo + '/enrollment/enrollmentPage'])
                    }
                )
        }
    }

    ngOnInit() {
        this.showQtip = false
        this.UILangEng = true

        if (sessionStorage.getItem('EnrollmentCache') != null) {
            sessionStorage.removeItem('EnrollmentCache')
        }

        this._authService.isAuthorization('phone-enrollment/ext')

        if (this._global === undefined || this._global.currentUser === undefined) {
            this._currentUserGateway.getCurrentUser().subscribe((user) => {
                if (user != null) {
                    this._global.currentUser = user

                    //Check phone enrollment access using bookmark and redirected them accordingly.
                    this.CheckPhoneEnrllAccess()
                    this.agentFullname = this._global.currentUser.firstName + ' ' + this._global.currentUser.lastName
                    this.insuranceComapny = this._global.currentUser.insuranceCompanyName
                    this.agentUserName = this._global.currentUser.userProfileName
                    this.AgentID = this._global.currentUser.userProfileId.toString()
                    this.setPageData()
                }
            })
        } else {
            //Check phone enrollment access using bookmark and redirected them accordingly.
            this.CheckPhoneEnrllAccess()
            if (this._global.currentUser.firstName !== undefined) {
                this.agentFullname = this._global.currentUser.firstName + ' ' + this._global.currentUser.lastName
            }
            this.setPageData()
        }
    }

    BenfDetails() {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/BeneficiaryDetails'])
    }
    SalesBenfDetails() {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/BeneficiaryDetails/6'])
    }

    setPageData() {
        if (this._global.currentUser.isCallCenterAgent) {
            this.CheckGoodStanding = true
        }
        this.selectedyear = this._global.selectedPlanYear
        if (this.selectedyear === this._global.PreviousPlanYear) {
            this.ShowCurrentYearScript = true
        }
        this.loadPlanList(this.selectedyear.toString())
        if (this._global.currentUser.insuranceCompanyName !== undefined) {
            this.insuranceComapny = this._global.currentUser.insuranceCompanyName
        }
        if (this._global.currentUser.userProfileName !== undefined) {
            this.agentUserName = this._global.currentUser.userProfileName
        } else {
            this.agentUserName = ''
        }
        if (this._global.currentUser.userProfileId !== undefined) {
            this.AgentID = this._global.currentUser.userProfileId.toString()
        }
        this.enrollment = this._enrollementGateway.getEnrollmentViewModel()
        if (this.enrollment.AGENTNAME !== undefined && this.enrollment.AGENTNAME !== null) {
            this.agentUserName = this.enrollment.AGENTNAME
        }
        if (this._global.selectedPlanYear.toString() === this._global.AEPPlanYearValue) {
            this.checkPlanyear = true
        } else {
            this.checkPlanyear = false
        }

        //Get the state using ZIPCODE
        this._callStartGateway.getStateByZipCode(this.enrollment.APPZIP).subscribe((data: any) => {
            if (data !== null || data !== undefined) {
                this.UserState = data
            }
        })

        this.sub = this.route.params.subscribe((params) => {
            this.calllogid = +params['callLogID']
            if (this.calllogid !== undefined && this.calllogid !== null) {
                this._enrollementGateway.GetPreEnrollmentBeneficiaryDtl(this.calllogid).subscribe((PreEnrollmentCallLogDetails) => {
                    if (PreEnrollmentCallLogDetails !== null && PreEnrollmentCallLogDetails !== undefined) {
                        this.callLog = PreEnrollmentCallLogDetails
                        this.fillCallLogDetails()
                        this.isQtip = true
                    }
                })
            }
        })
        if (this._global.currentUser.roleId !== undefined && !this._global.currentUser.IsGuruAdmin) {
            if (this._global.currentUser.IsEnoller) {
                this.isEnroller = true
            } else {
                this.isEnroller = false
            }
        }
        //    && this._global.currentUser.roleId !== undefined) {
        //if (this._global.currentUser.insuranceCompanyId !== undefined
        //    && this._global.currentUser.roleId !== undefined) {
        //    this._enrollementGateway.GetPhoneEnrollmentAcccessCheck
        //        (parseInt(this._global.currentUser.insuranceCompanyId), this._global.currentUser.roleId.toString())
        //        .subscribe(
        //            (model: any) => {
        //                if (model != null) {
        //                    this.IsPhoneEnrollmentAccess = model
        //                    if (this.IsPhoneEnrollmentAccess) {
        //                        if (this.calllogid !== undefined && this.calllogid !== null
        //                            && this.calllogid !== NaN) {
        //                            this.router.navigate(['enrollment/phone-enrollment/ext/Step1/' + this.calllogid])
        //                        }
        //                        else {
        //                            this.router.navigate(['enrollment/phone-enrollment/ext/Step1'])
        //                        }
        //                    }
        //                }
        //            })
        //}
        if (this._global.currentUser.orgId !== undefined) {
            this._enrollementGateway.CheckParentOragnizationId(parseInt(this._global.currentUser.orgId)).subscribe((data: number) => {
                this.currentOrgid = data.toString()
            })
        }
        this.SelectRblrecordOptions(this.enrollment.RBLRECORD)
        this.SelectRblrecordNoOptions(this.enrollment.RBLREP)
        this.SelectRblrblBenfeOptions(this.enrollment.RBLBENFE)
        this.SelectRblrblBenfeReplyOptions(this.enrollment.RBLBENFEREPLY)

        if (this.enrollment.PLANTYPE != null && this.enrollment.PLANTYPE != '' && this.enrollment.PLANTYPE != undefined) {
            if (this.enrollment.APPST != null && this.enrollment.APPST != '' && this.enrollment.APPST != undefined) {
                this.UserState = this.enrollment.APPST
            }
            this.setplanValue(this.enrollment.PLANTYPE)
        }
        //if (this.enrollment.AUTHREPCOPYIND === null || this.enrollment.AUTHREPCOPYIND === ''
        //    || this.enrollment.AUTHREPCOPYIND === undefined) {
        //    this.enrollment.AUTHREPCOPYIND = 'No'
        //}
        if (this._global.selectedPlanYear > this._global.Planyear2024) {
            this.visibleFrom2025 = true
        }
        this.setDataForBeneficary()
        this.setExternalData()
        this.setIndividualData()
    }

    setExternalData() {
        this.route.params.subscribe((params) => {
            if (params['ak'] !== undefined && params['eid'] !== undefined) {
                this.enrollment.ACCESSKEY = params['ak']
                this.enrollment.ENROLLMENTID = params['eid']
                this.enrollment.ISEXTERNALAGENT = true
                this.enrollment.FORMNAME = 'EXTERNALSMS'
                this.setDataForSSO()
            }
        })
    }

    setDataForSSO() {
        this.enrollmentHeader.EnrollmentID = this.enrollment.ENROLLMENTID
        this.enrollmentHeader.accesskey = this.enrollment.ACCESSKEY

        //Service call to set external data
        //this.loading = true
        this._enrollementGateway.getEnrollmentHeader(this.enrollmentHeader).subscribe(
            (model: EnrollmentField[]) => {
                this.enrollment.beneficiaryInfo = {} as BeneficiaryInfo
                this.benefitaryModel = {} as BeneficiaryInfo

                this.SEPReasonCodeList.push(
                    { value: '125', code: 'NewMedicare' },
                    { value: '126', code: 'ReturnUSA' },
                    { value: '128', code: 'Now65' },
                    { value: '200', code: 'NewOptin' },
                    { value: '201', code: 'EmployerCoverage' },
                    { value: '203', code: 'StatedataEntryStep1Premium' },
                    { value: '204', code: 'NoExtraHelp' },
                    { value: '205', code: 'MovedLTC' },
                    { value: '206', code: 'LeftPACE' },
                    { value: '207', code: 'LostCoverage' },
                    { value: '211', code: 'StatePAP' },
                    { value: '213', code: 'LeftMedigap' },
                    { value: '214', code: 'JoinedMedicareAdv' },
                    { value: '215', code: 'Other' },
                    { value: '218', code: 'Disenrolling' },
                    { value: '219', code: 'EndContract' },
                    { value: '221', code: 'NoSpecialNeedsPlan' },
                    { value: '222', code: 'NoticeEligible' },
                    { value: '223', code: 'LostPartB' }
                )

                for (let i = 0; i < model.length; i++) {
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.DEX) {
                        // this.selEnrollmentMethod = model[i].FieldValue
                        this.dataEntryStep1.DataSource = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.SOA) {
                        if (model[i].FieldValue !== undefined && model[i].FieldValue !== null) {
                            if (model[i].FieldValue.toUpperCase() === 'YES') {
                                // this.selSOA = 'ScopeIncluded'
                                this.dataEntryStep1.SOA = 'ScopeIncluded'
                            } else {
                                //  this.selSOA = 'ScopeNotIncluded'
                                this.dataEntryStep1.SOA = 'ScopeNotIncluded'
                            }
                        }
                    }

                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.ACCHOLDERNAME) {
                        this.enrollment.ACCHOLDERNAME = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.ELECTION) {
                        if (model[i].FieldValue === 'S') {
                            this.enrollment.ELECTION = 'Special'
                        } else if (model[i].FieldValue === 'I') {
                            this.enrollment.ELECTION = 'FirstTime'
                        } else {
                            this.enrollment.ELECTION = 'OpenEnrollment'
                        }
                        //  this.periodSelected = this.enrollment.ELECTION
                    }
                    //delete
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.RELCD) {
                        this.enrollment.RELCD = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.PLANTYPE) {
                        if (model[i].FieldValue === 'C') {
                            this.enrollment.PLANTYPE = 'CHOICE'
                        } else if (model[i].FieldValue === 'P') {
                            this.enrollment.PLANTYPE = 'PLUS'
                        } else if (model[i].FieldValue === 'S') {
                            this.enrollment.PLANTYPE = 'SMARTRX'
                        } else {
                            this.enrollment.PLANTYPE = model[i].FieldValue
                        }
                        this.onPlanChange(this.enrollment.PLANTYPE)
                    }
                    if (this.enrollment.FORMNAME !== 'EXTERNAL') {
                        if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPDT) {
                            this.benefitaryModel.applicationDate = new Date(moment(model[i].FieldValue).format('MM/DD/YYYY'))
                        }
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.EFFDT) {
                        this.benefitaryModel.effectiveEnrollmentDate = new Date(moment(model[i].FieldValue).format('MM/DD/YYYY'))
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPFN) {
                        this.benefitaryModel.firstName = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPLN) {
                        this.benefitaryModel.lastName = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.SUFFIX) {
                        this.benefitaryModel.suffixName = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPMI) {
                        this.benefitaryModel.middleInitial = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.TITLE) {
                        this.benefitaryModel.title = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.HICN) {
                        this.benefitaryModel.medicareId = model[i].FieldValue.toString().toUpperCase()
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.MEDA) {
                        if (model[i].FieldValue !== undefined && model[i].FieldValue !== '') {
                            this.benefitaryModel.medicarePartAEffectiveDate = new Date(moment(model[i].FieldValue).format('MM/DD/YYYY'))
                        } else {
                            this.benefitaryModel.medicarePartAEffectiveDate = null
                            this.enrollment.beneficiaryInfo.medicarePartAEffectiveDate = null
                        }
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.MEDB) {
                        if (model[i].FieldValue !== undefined && model[i].FieldValue !== '') {
                            this.benefitaryModel.medicarePartBEffectiveDate = new Date(moment(model[i].FieldValue).format('MM/DD/YYYY'))
                        } else {
                            this.benefitaryModel.medicarePartBEffectiveDate = null
                            this.enrollment.beneficiaryInfo.medicarePartBEffectiveDate = null
                        }
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPDOB) {
                        let myFormattedDate: any
                        this.pipe = new DatePipe('en-US')
                        myFormattedDate = this.pipe.transform(model[i].FieldValue, 'MM/dd/yyyy')
                        this.benefitaryModel.dateOfBirth = myFormattedDate
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPPHONE) {
                        this.benefitaryModel.primaryPhone = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPGEN) {
                        this.benefitaryModel.gender = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.CELLPHONE) {
                        this.benefitaryModel.cellPhone = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.EOB) {
                        if (
                            model[i].FieldValue !== undefined &&
                            (model[i].FieldValue.toUpperCase() === 'EEOB' || model[i].FieldValue.toUpperCase() === 'YES')
                        ) {
                            this.enrollment.EOB = 'EEOB'
                        } else {
                            this.enrollment.EOB = 'PEOB'
                        }
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPEMAIL) {
                        this.benefitaryModel.email = model[i].FieldValue
                        this.enrollment.beneficiaryInfo.email = model[i].FieldValue
                    }

                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPADD1) {
                        this.residentialAddress.addressLine1 = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPADD2) {
                        this.residentialAddress.addressLine2 = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPCITY) {
                        this.residentialAddress.city = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPZIP) {
                        this.residentialAddress.zip = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPST) {
                        this.residentialAddress.state = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.MAILINGADDRESSISSAME) {
                        if (model[i].FieldValue !== undefined && model[i].FieldValue.toUpperCase() === 'TRUE') {
                            this.residentialAddress.sameAddress = true
                        } else {
                            this.residentialAddress.sameAddress = false
                        }
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.LTCFACILITY) {
                        this.enrollment.LTCFACILITY = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.LTCPHONE) {
                        this.enrollment.LTCPHONE = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.NOTES) {
                        this.enrollment.NOTES = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.SEPREASONCD) {
                        let selSepReasonCode = this.SEPReasonCodeList.filter((x) => x.value === model[i].FieldValue)[0]
                        if (selSepReasonCode === undefined || selSepReasonCode === null) {
                            selSepReasonCode = this.SEPReasonCodeList.filter((x) => x.code === model[i].FieldValue)[0]
                        }
                        this.enrollment.SEPREASONCD = Number(selSepReasonCode.value)
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.MAILADD1) {
                        this.mailingAddress.addressLine1 = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.MAILADD2) {
                        this.mailingAddress.addressLine2 = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.MAILCITY) {
                        this.mailingAddress.city = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.MAILST) {
                        this.mailingAddress.state = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.MAILZIP) {
                        this.mailingAddress.zip = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.PWO) {
                        if (model[i].FieldValue === 'P') {
                            this.enrollment.PWO = 'Direct Bill'
                            this.enrollment.paymentOption = 'Direct Bill'
                        } else if (model[i].FieldValue === 'S') {
                            this.enrollment.PWO = 'Deduction from Social Security Check'
                            this.enrollment.paymentOption = 'Deduction from Social Security Check'
                        } else if (model[i].FieldValue === 'R') {
                            this.enrollment.PWO = 'Deduction from Railroad Retirement Board'
                            this.enrollment.paymentOption = 'Deduction from Railroad Retirement Board'
                        } else if (model[i].FieldValue === 'E') {
                            this.enrollment.PWO = 'Automatic Bank Draft Withdrawal'
                            this.enrollment.paymentOption = 'Automatic Bank Draft Withdrawal'
                        }
                        //  this.paymentOption = this.enrollment.PWO
                    }
                    //if (model[i].FieldCode === ExternalEnrollmentFieldCodes.AGENTID) {
                    //    this.enrollment.AGENTID = model[i].FieldValue
                    //}
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.PLANYEAR) {
                        this.enrollment.PLANYEAR = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.LANG) {
                        if (model[i].FieldValue === 'E') {
                            this.enrollment.LANG = 'English'
                        } else {
                            this.enrollment.LANG = 'Spanish'
                        }
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.OTHCVRG) {
                        if (model[i].FieldValue.toString().toUpperCase() === 'TRUE') {
                            this.enrollment.OTHCVRG = 'yes'
                            // this.showOtherCoverage = true
                        } else {
                            this.enrollment.OTHCVRG = 'no'
                            //  this.showOtherCoverage = false
                        }
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.LANGFORMAT) {
                        this.enrollment.EOB = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.ACCOUNTNB) {
                        this.enrollment.ACCOUNTNB = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.OTHCVRGNAME) {
                        this.enrollment.OTHCVRGNAME = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.OTHCVRGID) {
                        this.enrollment.OTHCVRGID = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.OTHCVRGGRP) {
                        this.enrollment.OTHCVRGGRP = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.COBBIN) {
                        this.enrollment.COBBIN = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.COBPCN) {
                        this.enrollment.COBPCN = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.COBEFFDT) {
                        if (model[i].FieldValue !== undefined && model[i].FieldValue !== '') {
                            this.enrollment.COBEFFDT = new Date(moment(model[i].FieldValue).format('MM/DD/YYYY'))
                        } else {
                            this.enrollment.COBEFFDT = null
                        }
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.COBTERMDT) {
                        if (model[i].FieldValue !== undefined && model[i].FieldValue !== '') {
                            this.enrollment.COBTERMDT = new Date(moment(model[i].FieldValue).format('MM/DD/YYYY'))
                        } else {
                            this.enrollment.COBTERMDT = null
                        }
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.FININSTNAME) {
                        this.enrollment.FININSTNAME = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.EFTTYPE) {
                        if (model[i].FieldValue === 'S') {
                            this.enrollment.EFTTYPE = 'SAVINGS'
                        } else if (model[i].FieldValue === 'C') {
                            this.enrollment.EFTTYPE = 'CHECKING'
                        }
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.ROUTINGNB) {
                        this.enrollment.ROUTINGNB = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.SEPEFFDT) {
                        if (model[i].FieldValue !== undefined && model[i].FieldValue !== '') {
                            this.enrollment.SEPEFFDT = new Date(moment(model[i].FieldValue).format('MM/DD/YYYY'))
                        } else {
                            this.enrollment.SEPEFFDT = null
                        }
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.AUTHREPNAME) {
                        this.enrollment.AUTHREPNAME = model[i].FieldValue
                        this.enrollment.AUTHREPIND = 'Yes'
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.AUTHREPPHONE) {
                        this.enrollment.AUTHREPPHONE = model[i].FieldValue
                        this.enrollment.AUTHREPIND = 'Yes'
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.AUTHREPREL) {
                        this.enrollment.AUTHREPREL = model[i].FieldValue
                        this.enrollment.AUTHREPIND = 'Yes'
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.AUTHREPADD1) {
                        this.enrollment.AUTHREPADD1 = model[i].FieldValue
                        this.enrollment.AUTHREPIND = 'Yes'
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.AUTHREPCITY) {
                        this.enrollment.AUTHREPCITY = model[i].FieldValue
                        this.enrollment.AUTHREPIND = 'Yes'
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.AUTHREPST) {
                        this.enrollment.AUTHREPST = model[i].FieldValue
                        this.enrollment.AUTHREPIND = 'Yes'
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.AUTHREPZIP) {
                        this.enrollment.AUTHREPZIP = model[i].FieldValue
                        this.enrollment.AUTHREPIND = 'Yes'
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.AUTHREPIND) {
                        if (model[i].FieldValue !== undefined) {
                            if (model[i].FieldValue.toUpperCase() !== 'YES' || model[i].FieldValue.toUpperCase() !== 'TRUE') {
                                this.enrollment.AUTHREPIND = 'Yes'
                            } else {
                                this.enrollment.AUTHREPIND = 'No'
                            }
                        }
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.AUTHREPSIGNEDIND) {
                        if (model[i].FieldValue !== undefined) {
                            if (model[i].FieldValue.toUpperCase() === 'YES' || model[i].FieldValue.toUpperCase() === 'TRUE') {
                                this.enrollment.AUTHREPSIGNEDIND = true
                            } else {
                                this.enrollment.AUTHREPSIGNEDIND = false
                            }
                        }
                    }
                    //if (model[i].FieldCode === ExternalEnrollmentFieldCodes.SOANOTINCLUDEDMAIL) {
                    //    if (model[i].FieldValue !== undefined && model[i].FieldValue.toUpperCase() === 'YES') {
                    //        this.SOANotIncludedMail = true
                    //    } else {
                    //        this.SOANotIncludedMail = false
                    //    }
                    //}
                }
                this.getAllStates()
            },
            (err) => {
                // this.loading = false
            }
        )
    }

    getAllStates() {
        if (this.states !== undefined && this.states.length > 0) {
            this.setExternState()
        } else {
            this._stateGateway.getAllStates().subscribe((state) => {
                for (let i = 0; i < state.length; i++) {
                    this.states.push({ value: state[i].value, text: state[i].text })
                }
                this.setExternState()
            })
        }
    }

    setExternState() {
        let resState = this.states.filter((x) => x.text === this.residentialAddress.state)
        if (resState !== undefined && resState.length > 0) {
            this.residentialAddress.state = String(resState[0].value)
        }
        let mailState = this.states.filter((x) => x.text === this.mailingAddress.state)
        if (mailState !== undefined && mailState.length > 0) {
            this.mailingAddress.state = String(mailState[0].value)
        }
        let AuthRepSt = this.states.filter((x) => x.text === this.enrollment.AUTHREPST)
        if (AuthRepSt !== undefined && AuthRepSt.length > 0) {
            this.enrollment.AUTHREPST = String(AuthRepSt[0].value)
        }
        this.enrollment.beneficiaryInfo = this.benefitaryModel
        this.enrollment.residentialAddress = this.residentialAddress
        this.enrollment.mailingAddress = this.mailingAddress
        //if (this.SOANotIncludedMail) {
        //    this.selEnrollmentMethod = 'Mail'
        //    this.dataEntryStep1.DataSource = 'Mail'

        //    this.selSOA = 'ScopeNotIncluded'
        //    this.dataEntryStep1.SOA = 'ScopeNotIncluded'
        //}

        this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
        // this.loading = false
    }

    SelectRblrecordOptions(isRblrecord: string) {
        if (isRblrecord === 'Yes') {
            this.rblrecordyes = true
            this.rblrecordno = false
            // if (!this.ShowCurrentYearScript) {
            this.rblrepyes = false
            this.rblrepno = true
            // }
        }
        if (isRblrecord === 'No') {
            this.rblrecordyes = false
            this.rblrecordno = true
        }
        this.enrollment.RBLRECORD = isRblrecord
        //this.rblrepyes = null
        //this.rblrepno = null
        //this.rblbenfeyes = null
        //this.rblbenfeno = null
        //this.rblbenfereplyyes = null
        //this.rblbenfereplyno = null
    }
    SelectRblrecordNoOptions(isRblrep: string) {
        if (isRblrep === 'Yes') {
            this.rblrepyes = true
            this.rblrepno = false
            this.rblbenfInfo = true
        }
        if (isRblrep === 'No') {
            this.rblrepyes = false
            this.rblrepno = true
            this.rblbenfInfo = true
        }
        this.enrollment.RBLREP = isRblrep
        //this.rblbenfeyes = null
        //this.rblbenfeno = null
        //this.rblbenfereplyyes = null
        //this.rblbenfereplyno = null
    }

    SelectRblrblBenfeOptions(isRblBene: string) {
        if (isRblBene === 'Yes') {
            this.rblbenfeyes = true
            this.rblbenfeno = false
            this.rblbenfInfo = false
            this.rblbenfereplyno = true
            this.enrollment.RBLBENFEREPLY = ''
            this.enrollment.INDREPIND = ''
            this.isVisibleIndiv = false
            this.showMyapologies()
        }
        if (isRblBene === 'No') {
            this.rblbenfeyes = false
            this.rblbenfeno = true
            this.rblbenfInfo = true
            this.isVisibleIndiv = true
            this.isAppInd = false
        }
        this.enrollment.RBLBENFE = isRblBene
        this.setScript()
        //this.rblbenfereplyyes = null
        //this.rblbenfereplyno = null
    }
    SelectRblrblBenfeReplyOptions(isRblBeneReply: string) {
        if (isRblBeneReply === 'Yes') {
            this.rblbenfereplyyes = true
            this.rblbenfereplyno = false
            this.rblbenfeno = false
            this.rblbenfInfo = false
        }
        if (isRblBeneReply === 'No') {
            this.rblbenfereplyyes = false
            this.rblbenfereplyno = true
            this.rblbenfeno = true
            this.rblbenfInfo = true
        }
        this.enrollment.RBLBENFEREPLY = isRblBeneReply
        this.showMyapologies()
    }

    formSubmit(): void {
        this.validateForm()
        // if (!this.isFormInvalid()) {

        //  enrollment.DateOfReceipt = DateTime.Now.ToShortDateString();

        // enrollment.IsFormComplete = false;

        //   enrollment.AdminId = Master.Agent.Id;
    }

    saveData() {
        this.enrollment.AGENTDEX = 'Phone'
        this.enrollment.DEX = 'AGNTP'
        this.enrollment.PLANYEAR = this._global.selectedPlanYear.toString()
        this.enrollment.AGENTNAME = this.agentUserName
        this.enrollment.AGENTID = this.AgentID // this._global.currentUser.userProfileId.toString()
        this.enrollment.USERNAME = this._global.currentUser.userProfileName
        this.enrollment.CUID = this.CUID
        this.enrollment.SUBMISSIONTYPECODE = 'PROSPECT'
        this.enrollment.STEPCODE = '1'
        this.enrollment.ADMINID = this._global.currentUser.userProfileId
        this.enrollment.USERPROFILEID = this._global.currentUser.userProfileId
        this.enrollment.INSURANCECOMPID = Number(this._global.currentUser.insuranceCompanyId)

        if (this.CUID === '9110') {
            this.enrollment.STEEREDIND = false
        } else {
            this.enrollment.STEEREDIND = true
        }

        this.enrollment.DATEOFRECEIPT = new Date()
        if (!this.rblbenfereplyno && !this.rblbenfeyes) {
            this.enrollment.AUTHREPIND = 'Yes'
        } else {
            this.enrollment.AUTHREPIND = 'No'
        }
        this.enrollment.CALLOGID = this.calllogid
        if (this.enrollment.ISSAMEADDRESS) {
            this.enrollment.MAILADD1 = this.enrollment.APPADD1
            this.enrollment.MAILADD2 = this.enrollment.APPADD2
            this.enrollment.MAILCITY = this.enrollment.APPCITY
            this.enrollment.MAILST = this.enrollment.APPST
            this.enrollment.MAILZIP = this.enrollment.APPZIP
        }
        if (this.enrollment.POBOX) {
            this.enrollment.POVERIND = '1'
        } else {
            this.enrollment.POVERIND = '0'
        }

        this.enrollment.Race = this._raceEthnicityComponent.submitRaceDynamic(this.enrollment.Race)
        this.enrollment.Ethnicity = this._raceEthnicityComponent.submitEthnicityDynamic(this.enrollment.Ethnicity)

        this.enrollment.displayEthnicity = this._raceEthnicityComponent.selectedEthnicityDynamicModel(this.enrollment.selectedEthnicity)
        this.enrollment.displayRace = this._raceEthnicityComponent.selectedRaceDynamicModel(this.enrollment.selecteRace)

        this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        //this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/ext/Step2'])
        // }
        this.loading = true
        let mailStateCode = this.enrollment.MAILST
        let mailZip = this.enrollment.MAILZIP
        if (this.enrollment.SAMEADDRESS) {
            mailStateCode = '0'
            mailZip = '0'
        }

        this._enrollementGateway
            .validateZipForAll(
                this.enrollment.APPST,
                this.enrollment.APPZIP,
                mailStateCode,
                mailZip,
                this.enrollment.AUTHREPST,
                this.enrollment.AUTHREPZIP
            )
            .subscribe(
                (model: string[]) => {
                    if (model !== undefined && model !== null && model.length !== 0) {
                        this.ErrorMessages = model
                        this.hasError = true
                        this.focusableEleTop.nativeElement.focus()
                        this.loading = false
                    } else {
                        // Remove data for the Indiviudal
                        if (!this.isAppInd || this.rblbenfeyes) {
                            this.enrollment.RELTOENROLL = ''
                            this.enrollment.displayRELTOENROLL = ''
                            this.enrollment.NPN = ''
                            this.enrollment.INDREPNAME = ''
                        }

                        this._enrollementGateway.SubmitEnrollmentData(this.enrollment).subscribe(
                            (model: SubmitEnrollmentDataResponse) => {
                                let response = model
                                if (response !== undefined) {
                                    if (response.Errors !== undefined && response.Errors.length > 0) {
                                        this.hasError = false

                                        for (let i = 0; i < response.Errors.length; i++) {
                                            this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                                        }
                                        this.loading = false
                                        this.hasError = true
                                        window.scrollTo(0, 0)
                                    } else {
                                        if (
                                            response.EnrollmentKey !== undefined &&
                                            response.EnrollmentKey !== '' &&
                                            response.EnrollmentKey !== null
                                        ) {
                                            this.enrollment.ENROLLKEY = response.EnrollmentKey
                                            this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
                                            this.loading = false

                                            this.enrollmentCacheData.EnrollmentKey = response.EnrollmentKey
                                            this.enrollmentCacheData.AgentName = this.enrollment.AGENTNAME
                                            this.enrollmentCacheData.AgentID = this.enrollment.AGENTID
                                            this.enrollmentCacheData.AdminID = this.enrollment.ADMINID
                                            this.enrollmentCacheData.AgentOrgID = this.enrollment.AGENTORGID
                                            this.enrollmentCacheData.USERNAME = this.enrollment.USERNAME
                                            this.enrollmentCacheData.FORMNAME = this.enrollment.FORMNAME
                                            this.enrollmentCacheData.PlanYear = this._global.selectedPlanYear
                                            this.enrollmentCacheData.CALLOGID = this.enrollment.CALLOGID
                                            this.enrollmentCacheData.RBLBENFE = this.enrollment.RBLBENFE

                                            sessionStorage.setItem('EnrollmentCache', JSON.stringify(this.enrollmentCacheData))

                                            this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/ext/Step2'])
                                        } else {
                                            this.ErrorMessages.push('Error while submitting data, please try again.')
                                            this.hasError = true
                                            this.loading = false
                                        }
                                        this.loading = false
                                    }
                                    this.loading = false
                                } else {
                                    this.ErrorMessages.push('Error while submitting data, please try again.')
                                    this.hasError = true
                                    this.loading = false
                                    window.scrollTo(0, 0)
                                }
                                this.loading = false
                            },
                            (err) => {
                                this.loading = false
                            }
                        )
                    }
                },
                (err) => {
                    this.loading = false
                }
            )
    }

    validateForm() {
        this.hasError = false
        this.ErrorMessages = [] as any[]
        if (this.isEnroller) {
            if (this.agentUserName === undefined || this.agentUserName === '') {
                this.ErrorMessages.push('AgentID is required')
                this.hasError = true
                this.focusableEleTop.nativeElement.focus()
            }
        }
        this._enrollementGateway.isValidAgent(this.agentUserName).subscribe((validAgentModel) => {
            let isagentvalid = true
            if (
                validAgentModel !== undefined &&
                validAgentModel.errorMessage !== '' &&
                validAgentModel.errorMessage !== null &&
                validAgentModel.errorMessage !== undefined
            ) {
                this.ErrorMessages.push(validAgentModel.errorMessage)
                isagentvalid = false
            }
            this.isValidAgent = isagentvalid
            if (!this.isValidAgent) {
                this.hasError = true
                this.focusableEleTop.nativeElement.focus()
            } else {
                this.hasError = false
                this.CUID = validAgentModel.CUID
                this.AgentID = String(validAgentModel.agentID)
                this.agentOrgId = validAgentModel.AgentOrgId
            }
            if (this.agentOrgId !== undefined && this.agentOrgId !== 0) {
                this._enrollementGateway.CheckParentOragnizationId(this.agentOrgId).subscribe((data: number) => {
                    this.enrollercurrentOrgid = data.toString()
                    if (this.isEnroller) {
                        if (this.enrollercurrentOrgid !== this.currentOrgid) {
                            this.ErrorMessages.push('Enrollers can only do enrollments for Agents in the same organization')
                            this.hasError = true
                            this.focusableEleTop.nativeElement.focus()
                        }
                    }
                })
            }
            if (this.CUID === undefined || this.CUID === '' || this.CUID === null) {
                this.ErrorMessages.push('CUID is required')
                this.hasError = true
                this.focusableEleTop.nativeElement.focus()
            }
            if (this.enrollment.PLANTYPE === undefined || this.enrollment.PLANTYPE === '') {
                this.ErrorMessages.push('Plan Type is required')
                this.hasError = true
            }
            //check beneficiary data
            if (!this.rblbenfInfo) {
                this.checkBenficiaryValidation()
            }
            // check authorize reprenatative
            if (!this.rblbenfereplyno && !this.rblbenfeyes) {
                if (this.enrollment.AUTHREPNAME === undefined || this.enrollment.AUTHREPNAME === '') {
                    this.ErrorMessages.push('Authorized Representative Name is required')
                    this.hasError = true
                    this.focusableEleTop.nativeElement.focus()
                }
                if (this.enrollment.AUTHREPST === undefined || this.enrollment.AUTHREPST === '') {
                    this.ErrorMessages.push('Authorized Representative State is required')
                    this.hasError = true
                    this.focusableEleTop.nativeElement.focus()
                }
                if (this.enrollment.AUTHREPADD1 === undefined || this.enrollment.AUTHREPADD1 === '') {
                    this.ErrorMessages.push('Authorized Representative Address is required')
                    this.hasError = true
                    this.focusableEleTop.nativeElement.focus()
                }
                if (this.enrollment.AUTHREPCITY === undefined || this.enrollment.AUTHREPCITY === '') {
                    this.ErrorMessages.push('Authorized Representative City is required')
                    this.hasError = true
                    this.focusableEleTop.nativeElement.focus()
                }
                if (this.enrollment.AUTHREPZIP === undefined || this.enrollment.AUTHREPZIP === '') {
                    this.ErrorMessages.push('Authorized Representative Zip is required')
                    this.hasError = true
                    this.focusableEleTop.nativeElement.focus()
                }
                if (this.enrollment.AUTHREPREL === undefined || this.enrollment.AUTHREPREL === '') {
                    this.ErrorMessages.push('Authorized Representative Relationship is required')
                    this.hasError = true
                    this.focusableEleTop.nativeElement.focus()
                }
                if (this.enrollment.AUTHREPNAME !== undefined && this.enrollment.AUTHREPNAME !== '' && this.enrollment.AUTHREPNAME !== null) {
                    let checkLName = this.enrollment.AUTHREPNAME,
                        regexFNameVal = new RegExp('^[a-zA-Z- ]*$')
                    let isLnameValid = regexFNameVal.test(checkLName)
                    if (!isLnameValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Authorized Representative Relationship Name is invalid')
                        this.focusableEleTop.nativeElement.focus()
                    }
                }
                if (this.enrollment.AUTHREPPHONE !== undefined && this.enrollment.AUTHREPPHONE !== '' && this.enrollment.AUTHREPPHONE !== null) {
                    let checkOrgPhone = this.enrollment.AUTHREPPHONE.replace(/-/g, '')
                    if (/^\d{10}$/.test(checkOrgPhone)) {
                    } else {
                        if (!this.isValidNumber(checkOrgPhone)) {
                            this.ErrorMessages.push('Authorized Representative Phone Number is invalid')
                            this.hasError = true
                            this.focusableEleTop.nativeElement.focus()
                        } else {
                            this.ErrorMessages.push('Authorized Representative Phone Number is invalid')
                            this.hasError = true
                            this.focusableEleTop.nativeElement.focus()
                        }
                    }
                }
                if (this.enrollment.AUTHREPZIP !== undefined && this.enrollment.AUTHREPZIP !== '' && this.enrollment.AUTHREPZIP !== null) {
                    let checkZipCode = this.enrollment.AUTHREPZIP,
                        regexVal = new RegExp('[0-9]{5}')
                    let isZipCodeValid = regexVal.test(checkZipCode)
                    if (!isZipCodeValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Authorized Representative Zip is invalid')
                        this.focusableEleTop.nativeElement.focus()
                    } //else {
                    //    this._enrollementGateway.validateZipCode(this.enrollment.AUTHREPST, this.enrollment.AUTHREPZIP)
                    //        .subscribe(
                    //        (model: string) => {
                    //            if (model !== undefined && model !== null && model.length !== 0) {
                    //                this.ErrorMessages.push(model)
                    //                this.hasError = true
                    //                this.focusableEleTop.nativeElement.focus()
                    //            } else {

                    //                    }
                    //                })
                    //    }
                }
                if (this.enrollment.AUTHREPEMAIL !== undefined && this.enrollment.AUTHREPEMAIL !== '') {
                    let unicodeRange = '(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])'
                    let checkOrgEmail = this.enrollment.AUTHREPEMAIL.toLowerCase()
                    //regexVal = new RegExp(
                    //    `^` +
                    //    `(` +
                    //    `?:[a-z0-9!#$%&'*+/=?^_\`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_\`{|}~-]+)*|"` +
                    //    `${unicodeRange}*"` +
                    //    `)` +
                    //    `@` +
                    //    `(` +
                    //    `?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+` +
                    //    `[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|` +
                    //    `\\[` +
                    //    `(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}` +
                    //    `(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:${unicodeRange}+)` +
                    //    `\\]` +
                    //    `)` +
                    //    `$`
                    //)
                    let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
                    if (!isOrgEmailValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Invalid Email address for Phone Enrollment')
                    }
                    //this.ErrorMessages.push('Email Address is required for Electronic Explanation of Benefits')
                    //this.hasError = true
                }
            }
            if (this.enrollment.RBLBENFE === undefined || this.enrollment.RBLBENFE === null || this.enrollment.RBLBENFE == '') {
                this.ErrorMessages.push('Beneficiary is required')
                this.hasError = true
            }
            if (this.enrollment.RBLBENFE === 'No') {
                if (this.enrollment.RBLBENFEREPLY === undefined || this.enrollment.RBLBENFEREPLY === null || this.enrollment.RBLBENFEREPLY == '') {
                    this.ErrorMessages.push('Authorized Representative is required')
                    this.hasError = true
                }
            }

            if (this.enrollment.INDREPIND === 'Yes') {
                if (this.enrollment.INDREPNAME === undefined || this.enrollment.INDREPNAME === null || this.enrollment.INDREPNAME == '') {
                    this.ErrorMessages.push('Individual Rep Name is required')
                    this.hasError = true
                }
                if (this.enrollment.RELTOENROLL === undefined || this.enrollment.RELTOENROLL === null || this.enrollment.RELTOENROLL == '') {
                    this.ErrorMessages.push('Relationship to enrollee is required')
                    this.hasError = true
                }
                if (
                    (this.enrollment.displayRELTOENROLL == 'Agent' || this.enrollment.displayRELTOENROLL == 'Broker') &&
                    (this.enrollment.NPN === undefined || this.enrollment.NPN === null || this.enrollment.NPN == '')
                ) {
                    this.ErrorMessages.push('National Producer Number is required')
                    this.hasError = true
                }

                if (this.enrollment.NPN != undefined && this.enrollment.NPN != null && this.enrollment.NPN != '') {
                    if (!this.utils.isValidNPN(this.enrollment.NPN)) {
                        this.hasError = true
                        this.ErrorMessages.push('Invalid NPN')
                    }
                }
            }
            if (!this.hasError) {
                // if (this.rblbenfeyes)
                if (this.rblbenfereplyno) {
                    this.enrollment.AUTHREPNAME = ''
                    this.enrollment.AUTHREPPHONE = ''
                    this.enrollment.AUTHREPREL = ''
                    this.enrollment.AUTHREPADD1 = ''
                    this.enrollment.AUTHREPCITY = ''
                    this.enrollment.AUTHREPST = ''
                    this.enrollment.AUTHREPZIP = ''
                    this.enrollment.AUTHREPCOPYIND = ''
                    this.enrollment.AUTHREPSIGNEDIND = false
                }

                this.saveData()
            } else {
                this.focusableEleTop.nativeElement.focus()
            }
        })

        // return this.hasError
    }

    private isValidEmail(text: string): boolean {
        return /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,}|[0-9]{1,3})(\]?)$/.test(text)
    }

    private isValidNumber(text: string): boolean {
        return /^\d*$/.test(text)
    }

    fillCallLogDetails() {
        if (this.calllogid !== undefined && this.calllogid !== null && this.callLog !== undefined && this.callLog !== null) {
            this.enrollment.APPFN = this.callLog.FirstName
            this.enrollment.APPLN = this.callLog.LastName
            this.enrollment.APPGEN = this.callLog.Gender
            this.enrollment.HICN = this.callLog.MedicareId
            this.enrollment.APPADD1 = this.callLog.StreetAddress
            this.enrollment.APPCITY = this.callLog.City
            this.enrollment.APPST = this.callLog.StateAbbreviation
            this.enrollment.APPZIP = this.callLog.Zipcode
            if (this.callLog.DateOfBirth != undefined) {
                let dobdate = moment(this.callLog.DateOfBirth, 'MM/DD/YYYY', true).format('MM/DD/YYYY').toString()
                if (dobdate != '' && dobdate != null && dobdate !== '01/01/1900') {
                    this.enrollment.APPDOB = this.callLog.DateOfBirth
                }
            }
            this.enrollment.APPPHONE = this.callLog.PhoneNumber
            this.enrollment.TITLE = this.callLog.Title
            this.enrollment.IsBeneficiary = this.callLog.IsBeneficiary
            this.enrollment.CALLOGID = this.calllogid
            this.enrollment.CALLENROLLMENTSTARTTIME = moment().format('YYYY-MM-DD')
            this.enrollment.LANG = this.callLog.Lang
            if (this.enrollment.LANG != undefined && this.enrollment.LANG != null) {
                if (this.enrollment.LANG == 'Spanish') {
                    this.UILangEng = false
                }
            } else {
                this.UILangEng = true
            }
        }
    }
    keyDownFunction(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.formSubmit()
        }
    }

    setDataForBeneficary() {
        if (this._global.currentUser.orgId !== undefined) {
            //For Call agent Set STEEREDIND=true
            this.enrollment.STEEREDIND = true

            if (this.enrollment.AGENTNAME === undefined || this.enrollment.AGENTNAME === '')
                this.enrollment.AGENTNAME = this._global.currentUser.userProfileName

            //Get License state for care rep
            this._licenseAppGateway.getUserLicenseDetailsForEnrollment(this.enrollment.AGENTNAME).subscribe((state) => {
                for (let i = 0; i < state.length; i++) {
                    this.states.push({ value: state[i].value, text: state[i].text })
                }

                _.remove(this.states, function (sta) {
                    return sta.value === 'PR' || sta.value === 'VI'
                })

                this.states.unshift({ value: '0', text: '-- Choose One --' })

                if (
                    this.enrollment.APPST === undefined ||
                    this.enrollment.APPST === '' ||
                    this.enrollment.APPST === '0' ||
                    this.enrollment.APPST === null
                ) {
                    this.enrollment.APPST = '0'
                }
                //this.setData()
                this.setBeneficiaryData()
            })

            this._enrollementGateway
                .GetAllParentStatesForOrg(parseInt(this._global.currentUser.orgId))
                .subscribe((states: ValidatedSelectOptionModel[]) => {
                    states.unshift({ value: '0', text: '-- Choose One --' })

                    _.remove(states, function (sta) {
                        return sta.value === 'PR' || sta.value === 'VI'
                    })

                    this.mailingstates = states

                    if (
                        this.enrollment.MAILST === undefined ||
                        this.enrollment.MAILST === '' ||
                        this.enrollment.MAILST === '0' ||
                        this.enrollment.MAILST === null
                    ) {
                        this.enrollment.MAILST = '0'
                    }
                    this.setBeneficiaryData()
                    //this.mailingstates.unshift({ value: 0, text: '-- Choose One --', })
                })
        } else {
            this.setBeneficiaryData()
        }
    }

    setBeneficiaryData() {
        this.enrollment.isPhoneEnrollment = true
        this.titleOptions = [
            { value: 'MR', text: 'MR' },
            { value: 'MRS', text: 'MRS' },
            { value: 'DR', text: 'DR' },
            { value: 'MS', text: 'MS' }
        ]

        this.genderOptions = [
            { value: 'M', htmlLabel: 'M' },
            { value: 'F', htmlLabel: 'F' }
        ]

        if (this.enrollment.POVERIND !== '' && this.enrollment.POVERIND !== null && this.enrollment.POVERIND !== undefined) {
            if (this.enrollment.POVERIND == '1') {
                this.enrollment.POBOX = true
            } else {
                this.enrollment.POBOX = false
            }
        }

        if (this.enrollment.ISSAMEADDRESS !== null && this.enrollment.ISSAMEADDRESS !== undefined) {
            this.clickOnSameAsBusinessAddress(this.enrollment.ISSAMEADDRESS)
        }

        if (this.enrollment.APPST !== '' && this.enrollment.APPST !== null && this.enrollment.APPST !== undefined) {
            this.SelectState(this.enrollment.APPST)
        }

        if (this.enrollment.CALLOGID !== 0 && this.enrollment.CALLOGID !== null && this.enrollment.CALLOGID !== undefined) {
            this.isQtip = true
        }
        this.AgentFullName =
            (this.enrollment.APPFN === null ? '' : this.enrollment.APPFN) + ' ' + (this.enrollment.APPLN === null ? '' : this.enrollment.APPLN)
        this.setScript()
        if (this.enrollment.APPGEN !== '' && this.enrollment.APPGEN !== null && this.enrollment.APPGEN !== undefined) {
            this.SelectGender(this.enrollment.APPGEN)
        }
    }
    clickOnSameAsBusinessAddress(val: boolean) {
        if (val) {
            this.IsSameAddress = false
            this.enrollment.MAILADD1 = this.enrollment.APPADD1
            this.enrollment.MAILADD2 = this.enrollment.APPADD2
            this.enrollment.MAILCITY = this.enrollment.APPCITY
            this.enrollment.MAILST = this.enrollment.APPST
            this.enrollment.MAILZIP = this.enrollment.APPZIP
        } else {
            this.IsSameAddress = true
            this.enrollment.MAILADD1 = ''
            this.enrollment.MAILADD2 = ''
            this.enrollment.MAILCITY = ''
            this.enrollment.MAILST = ''
            this.enrollment.MAILZIP = ''
        }

        //  this.sameAsBusinessAddress = !this.sameAsBusinessAddress
        this.enrollment.ISSAMEADDRESS = val
    }
    SelectState(selectstate: string) {
        if (selectstate !== '' && selectstate !== undefined && selectstate !== '0') {
            this.planstatename = selectstate
        }
        this.enrollment.APPST = selectstate
        this.UserState = this.enrollment.APPST
        if (this.states !== undefined && this.states !== null) {
            if (this.states.length > 0) this.planstatename = this.states.filter((x) => x.value === selectstate)[0].text
        }

        if (this.enrollment.PLANTYPE != null && this.enrollment.PLANTYPE != '' && this.enrollment.PLANTYPE != undefined) {
            if (this.UserState != undefined && this.UserState != null && this.UserState != '') {
                this.setplanValue(this.enrollment.PLANTYPE)
            }
        }
    }
    checkBenficiaryValidation() {
        if (this.enrollment.APPFN === undefined || this.enrollment.APPFN === '' || this.enrollment.APPFN === null) {
            this.ErrorMessages.push('First Name is required')
            this.hasError = true
        }
        if (this.enrollment.APPLN === undefined || this.enrollment.APPLN === '' || this.enrollment.APPLN === null) {
            this.ErrorMessages.push('Last Name is required')
            this.hasError = true
        }

        if (this.enrollment.APPDOB === undefined || this.enrollment.APPDOB === null) {
            this.ErrorMessages.push('Date of Birth is required')
            this.hasError = true
        } else {
            let dob = moment(this.enrollment.APPDOB, 'MM/DD/YYYY')
            if (!dob.isValid()) {
                this.ErrorMessages.push('Date of Birth does not contain a valid Date')
                this.hasError = true
            } else {
                if (dob.isSameOrBefore('12/31/1889')) {
                    this.hasError = true
                    this.ErrorMessages.push('Invalid Date of Birth.')
                }
            }
        }

        if (this.enrollment.APPGEN === undefined || this.enrollment.APPGEN === '' || this.enrollment.APPGEN === null) {
            this.ErrorMessages.push('Gender is required')
            this.hasError = true
        }
        if (this.enrollment.APPADD1 === undefined || this.enrollment.APPADD1 === '' || this.enrollment.APPADD1 === null) {
            this.ErrorMessages.push('Address1 is required')
            this.hasError = true
        }
        if (this.enrollment.APPCITY === undefined || this.enrollment.APPCITY === '' || this.enrollment.APPCITY === null) {
            this.ErrorMessages.push('City is required')
            this.hasError = true
        } else {
            let regexCityVal = /^[A-Za-z\s\-. ]+$/

            let isCityValid = regexCityVal.test(this.enrollment.APPCITY)
            if (!isCityValid) {
                this.hasError = true
                this.ErrorMessages.push('Please enter valid City')
            }
        }

        if (this.enrollment.APPST === undefined || this.enrollment.APPST === '' || this.enrollment.APPST === '0') {
            this.ErrorMessages.push('State is required')
            this.hasError = true
        }
        if (this.enrollment.APPZIP === undefined || this.enrollment.APPZIP === '') {
            this.ErrorMessages.push('Zip is required')
            this.hasError = true
        }

        if (this.enrollment.MAILADD1 === undefined || this.enrollment.MAILADD1 === '') {
            this.ErrorMessages.push('Mailing Address1 is required')
            this.hasError = true
        }
        if (this.enrollment.MAILCITY === undefined || this.enrollment.MAILCITY === '') {
            this.ErrorMessages.push('Mailing City is required')
            this.hasError = true
        } else {
            let regexCityVal = /^[A-Za-z\s\-. ]+$/

            let isCityValid = regexCityVal.test(this.enrollment.MAILCITY)
            if (!isCityValid) {
                this.hasError = true
                this.ErrorMessages.push('Please enter valid Mailing City')
            }
        }
        //    let isCityValid = regexCityVal.test(this.enrollmentViewModel.MAILCITY)
        //    if (!isCityValid) {
        //        this.hasError = true
        //        this.ErrorMessages.push('Please enter valid Mailing City')
        //    }
        //}
        if (this.enrollment.MAILST === undefined || this.enrollment.MAILST === '' || this.enrollment.MAILST === '0') {
            this.ErrorMessages.push('Mailing State is required')
            this.hasError = true
        }
        if (this.enrollment.MAILZIP === undefined || this.enrollment.MAILZIP === '') {
            this.ErrorMessages.push('Mailing Zip is required')
            this.hasError = true
        }
        if (this.enrollment.MAILZIP !== undefined && this.enrollment.MAILZIP !== '' && this.enrollment.MAILZIP !== null) {
            let checkZipCode = this.enrollment.MAILZIP,
                regexVal = new RegExp('[0-9]{5}')
            let isZipCodeValid = regexVal.test(checkZipCode)
            if (!isZipCodeValid) {
                this.hasError = true
                this.ErrorMessages.push('Zip must be exactly 5 numbers')
            }
        }
        if (this.enrollment.APPFN !== undefined && this.enrollment.APPFN !== '' && this.enrollment.APPFN !== null) {
            let checkFName = this.enrollment.APPFN,
                regexFNameVal = new RegExp("^[a-zA-Z.' ]*$")
            let isFnameValid = regexFNameVal.test(checkFName)
            if (!isFnameValid) {
                this.hasError = true
                this.ErrorMessages.push('First Name is invalid')
            }
        }

        if (this.enrollment.APPLN !== undefined && this.enrollment.APPLN !== '' && this.enrollment.APPLN !== null) {
            let checkLName = this.enrollment.APPLN,
                regexFNameVal = new RegExp("^[a-zA-Z.' -]*$")
            let isLnameValid = regexFNameVal.test(checkLName)
            if (!isLnameValid) {
                this.hasError = true
                this.ErrorMessages.push('Last Name is invalid')
            }
        }
        if (this.enrollment.APPMI !== undefined && this.enrollment.APPMI !== '' && this.enrollment.APPMI !== null) {
            let checkMI = this.enrollment.APPMI,
                regexMIVal = new RegExp('^[a-zA-Z ]*$')
            let isMiValid = regexMIVal.test(checkMI)
            if (!isMiValid) {
                this.hasError = true
                this.ErrorMessages.push('MI is invalid')
            }
        }

        if (this.enrollment.APPZIP !== undefined && this.enrollment.APPZIP !== '' && this.enrollment.APPZIP !== null) {
            let checkZipCode = this.enrollment.APPZIP,
                regexVal = new RegExp('[0-9]{5}')
            let isZipCodeValid = regexVal.test(checkZipCode)
            if (!isZipCodeValid) {
                this.hasError = true
                this.ErrorMessages.push('Zip must be exactly 5 numbers')
            }
        }

        if (this.enrollment.APPPHONE !== undefined && this.enrollment.APPPHONE !== '' && this.enrollment.APPPHONE !== null) {
            let checkOrgPhone = this.enrollment.APPPHONE.replace(/-/g, '')
            if (/^\d{10}$/.test(checkOrgPhone)) {
            } else {
                if (!this.isValidNumber(checkOrgPhone)) {
                    this.ErrorMessages.push('Phone cannot contain letters or special characters.')
                    this.hasError = true
                } else {
                    this.ErrorMessages.push('Phone must be exactly 10 numbers.')
                    this.hasError = true
                }
            }
        }
        if (this.enrollment.APPEMAIL !== undefined && this.enrollment.APPEMAIL !== '' && this.enrollment.APPEMAIL !== null) {
            let unicodeRange = '(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])'
            let checkOrgEmail = this.enrollment.APPEMAIL.toLowerCase()

            let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
            if (!isOrgEmailValid) {
                this.hasError = true
                this.ErrorMessages.push('Email Address is invalid.')
            }
            //this.ErrorMessages.push('Email Address is required for Electronic Explanation of Benefits')
            //this.hasError = true
        }

        if (this.enrollment.PLANST === 'AK' && this.enrollment.PLANTYPE === 'PLUS') {
            this.ErrorMessages.push('SilverScript Plus plan is not available for Alaska state.')
            this.hasError = true
        }
    }
    SelectGender(event: any) {
        this.enrollment.APPGEN = event
        if (this.enrollment.RBLBENFE == 'No') {
            if (this.enrollment.TITLE === 'Mr' || this.enrollment.APPGEN === 'M') {
                this.spnyouheshe = 'he'
                this.spnyourhisher = 'his'
                this.spnyouhimher = 'him'
                this.spnYouheshe = 'he'
                this.spnIsBeneficiary2 = 'he'
                this.spnyouthey = 'they'
            } else if (this.enrollment.TITLE === 'Mrs' || this.enrollment.TITLE === 'Ms' || this.enrollment.APPGEN === 'F') {
                this.spnyouheshe = 'she'
                this.spnyourhisher = 'her'
                this.spnyouhimher = 'her'
                this.spnYouheshe = 'she'
                this.spnIsBeneficiary2 = 'she'
                this.spnyouthey = 'they'
            } else {
                this.spnyouheshe = 'he/she'
                this.spnyourhisher = 'his/her'
                this.spnyouhimher = 'him/her'
                this.spnYouheshe = 'he/she'
                this.spnIsBeneficiary2 = ' he/she '
                this.spnyouthey = 'they'
            }
        }
    }
    setScript() {
        if (this.enrollment.RBLBENFE === 'Yes') {
            this.spnIsBeneficiary = 'you '
            this.spnIsBeneficiary2 = 'you '
            this.spnIsAre = 'are '
            this.spnYourMediBeneficiary = 'your '
            this.spnDoDoes = 'Do '
            this.spnIsAreCapt = 'Are '
            this.spnIsBeneficiaryYour = 'your '
            this.spnIsQualify = 'qualify '
            this.spnYouThey = 'you '
            this.spnYourTheir = 'your '
            this.spnHasHave = 'have '
            this.spnIsReside = ''
            this.spnyouheshe = 'you'
            this.spnyourhisher = 'your'
            this.spnYourBeneficiaryNew = 'your '
            this.spnIsBeneficiaryYou = 'you'
            this.spnyouhimher = 'you'
            this.spndodoes = 'do'
            this.spnyoubenef = 'you'
            this.spnYouheshe = 'You'
            this.spnYoutheenrollee = 'you'
            this.spnnameofMedicare = 'you'
            this.spnyouthey = 'you'
        }
        if (
            this.enrollment.RBLBENFE === 'No' &&
            this.AgentFullName !== ' ' &&
            this.AgentFullName !== '' &&
            this.AgentFullName !== 'undefined undefined'
        ) {
            this.spnIsBeneficiary = this.AgentFullName
            this.spnIsBeneficiary2 = ' he/she '
            this.spnyouthey = 'you/they'
            this.spnIsAre = 'is '
            this.spnYourMediBeneficiary = 'the Medicare Beneficiary’s '
            this.spnDoDoes = 'Does '
            this.spnIsAreCapt = 'Is '
            this.spnIsBeneficiaryYour = 'the enrollee’s'
            this.spnIsQualify = 'qualifies '
            this.spnYouThey = 'they '
            this.spnYourTheir = 'their '
            this.spnHasHave = 'has '
            this.spnIsReside = '(s)'
            this.spnYourBeneficiaryNew = 'Medicare beneficiary '
            this.spnIsBeneficiaryYou = 'enrollee'
            this.spndodoes = 'does'
            this.spnyoubenef = 'you as the authorized representative for the beneficiary'
            this.spnYoutheenrollee = this.AgentFullName
            this.spnnameofMedicare = this.AgentFullName
            if (this.enrollment.TITLE === 'Mr' || this.enrollment.APPGEN === 'M') {
                this.spnyouheshe = 'he'
                this.spnyourhisher = 'his'

                this.spnyouhimher = 'him'
                this.spnYouheshe = 'he'
                this.spnIsBeneficiary2 = ' he '
                this.spnyouthey = 'they'
            } else if (this.enrollment.TITLE === 'Mrs' || this.enrollment.TITLE === 'Ms' || this.enrollment.APPGEN === 'F') {
                this.spnyouheshe = 'she'
                this.spnyourhisher = 'her'

                this.spnyouhimher = 'her'
                this.spnYouheshe = 'she'
                this.spnIsBeneficiary2 = ' she '
                this.spnyouthey = 'they'
            } else {
                this.spnyouheshe = 'he/she'
                this.spnyourhisher = 'his/her'

                this.spnyouhimher = 'him/her'
                this.spnYouheshe = 'he/she'
                this.spnyouthey = 'they'
            }
        }
        if (
            this.enrollment.RBLBENFE === 'No' &&
            (this.AgentFullName === ' ' || this.AgentFullName === 'undefined undefined' || this.AgentFullName === '')
        ) {
            this.spnIsBeneficiary = ' enrollee’s name'
            this.spnIsBeneficiary2 = ' he/she '
            this.spnIsAre = 'is'
            this.spnYourMediBeneficiary = 'the Medicare Beneficiary’s'
            this.spnDoDoes = 'Does '
            this.spnIsAreCapt = 'Is '
            this.spnIsBeneficiaryYour = 'the enrollee’s'
            this.spnIsQualify = 'qualifies'
            this.spnYouThey = 'they'
            this.spnYourTheir = 'their'
            this.spnHasHave = 'has'
            this.spnIsReside = '(s)'
            this.spnyouheshe = 'he/she'
            this.spnyourhisher = 'his/her'

            this.spnIsBeneficiaryYou = 'enrollee'
            this.spnYourBeneficiaryNew = 'Medicare beneficiary'
            this.spnyouhimher = 'him/her'
            this.spndodoes = 'does'
            this.spnyoubenef = 'you as the authorized representative for the beneficiary'
            this.spnYouheshe = 'he/she'
            this.spnYoutheenrollee = 'the enrollee name'
            this.spnnameofMedicare = 'name of Medicare beneficiary'
            this.spnyouthey = 'you/they'
        }
        if (this.enrollment.RBLBENFE === undefined || this.enrollment.RBLBENFE === '' || this.enrollment.RBLBENFE === null) {
            this.spnIsBeneficiary = ' you/enrollee’s name'
            this.spnIsBeneficiary2 = 'you/he/she'
            this.spnIsAre = 'is/are'
            this.spnYourMediBeneficiary = 'the Medicare Beneficiary’s'
            this.spnDoDoes = 'Do/Does '
            this.spnIsAreCapt = 'Is/Are '
            this.spnIsBeneficiaryYour = 'the enrollee’s'
            this.spnIsQualify = 'qualifies'
            this.spnYouThey = 'you/they'
            this.spnYourTheir = 'your/their'
            this.spnHasHave = 'has/have'
            this.spnIsReside = '(s)'
            this.spnyouheshe = 'you/he/she'
            this.spnyourhisher = 'your/his/her'

            this.spnIsBeneficiaryYou = 'you/enrollee'
            this.spnYourBeneficiaryNew = 'Medicare beneficiary'
            this.spnyouhimher = 'you/him/her'
            this.spndodoes = 'do/does'
            this.spnyoubenef = 'you/you as the authorized representative for the beneficiary'
            this.spnYouheshe = 'you/he/she'
            this.spnYoutheenrollee = 'you/the enrollee name'
            this.spnnameofMedicare = 'you/name of Medicare beneficiary'
            this.spnyouthey = 'you/they'
        }
    }
    setplanValue(planType: string): void {
        this._enrollementGateway
            .getPlanPremium(Number(this._global.currentUser.orgId), this.selectedyear.toString(), planType, this.UserState)
            .subscribe((model: string) => {
                this.planvalue = model
            })
    }

    onPlanChange(planType: string) {
        if (planType !== undefined && planType !== '' && planType !== null) {
            this.enrollment.PLANTYPE = planType
            if (this.optionrbPlan !== undefined && this.optionrbPlan !== null) {
                if (this.optionrbPlan.length > 0) this.enrollment.PLANTYPENAME = this.optionrbPlan.filter((x) => x.value === planType)[0].htmlLabel
                if (this.UserState !== undefined && this.UserState !== null && this.UserState != '') this.setplanValue(this.enrollment.PLANTYPE)
            }
        }
    }

    loadPlanList(PLANYEAR: string) {
        if (PLANYEAR !== null) {
            this.loading = true
            this._enrollementGateway.getPlanList(parseInt(this._global.currentUser.orgId), PLANYEAR).subscribe(
                (model: PlanList[]) => {
                    this.planList = model
                    this.getPlanList(this.planList)

                    //this.setData()
                    this.loading = false
                },
                (err) => {
                    this.loading = false
                }
            )
        }
    }
    // Individual start

    // notBlankValidator = new NotBlankGenericFieldValidator()
    // @Input() isSpanish: boolean
    // @Input() AgentOrgID: Number

    // @Input() enrollmentindvrepViewModel: EnrollmentViewModel
    public rblReltoEnroll: ValidatedSelectOptionModel[] = []
    //visibleFrom2025: boolean
    isAppInd: boolean | null
    public rblAppIndIND: ValidatedRadioButtonModel[] = []
    public relationshipToEnrolleeList: RelationshipToEnrollee[] = [] as RelationshipToEnrollee[]

    setIndividualData() {
        // this.visibleFrom2025 = (this._global.selectedPlanYear > this._global.Planyear2024);
        if (this.enrollment.INDREPIND == 'Yes') {
            this.isAppInd = true
        } else if (this.enrollment.INDREPIND == 'No') {
            this.isAppInd = false
        } else {
            this.isAppInd = null
        }

        this.rblAppIndIND.push({ value: 'No', htmlLabel: 'No' }, { value: 'Yes', htmlLabel: 'Yes' })

        this._enrollementGateway.getRelationshipToEnrolleeData().subscribe((model: RelationshipToEnrollee[]) => {
            this.relationshipToEnrolleeList = model

            this.relationshipToEnrolleeList.forEach((element, index) => {
                this.rblReltoEnroll.push({ value: element.RelationshipToEnrolleeCode, text: element.RelationshipToEnrolleeValue })
            })
        })

        this.relToEnrollonValueChange(this.enrollment.RELTOENROLL)
    }

    rblAppIndINDClick(event: any): void {
        if (event === 'Yes') {
            this.isAppInd = true
        } else {
            this.isAppInd = false
        }
        this.enrollment.INDREPIND = event

        this.showMyapologies()
    }

    showMyapologies() {
        if (this.visibleFrom2025) {
            if (this.enrollment.INDREPIND === 'No' && this.enrollment.RBLBENFEREPLY === 'No') {
                this.isMyAplgy = true
            } else {
                this.isMyAplgy = false
            }
        } else {
            if (this.enrollment.RBLBENFEREPLY === 'No') {
                this.isMyAplgy = true
            } else {
                this.isMyAplgy = false
            }
        }
    }
    isNPNmandatory: boolean = false
    relToEnrollonValueChange(value: any): void {
        this.enrollment.RELTOENROLL = value
        this.relationshipToEnrolleeList.forEach((element, index) => {
            if (element.RelationshipToEnrolleeCode == Number(value)) {
                this.enrollment.displayRELTOENROLL = element.RelationshipToEnrolleeValue
            }
        })
        if (this.enrollment.displayRELTOENROLL == 'Agent' || this.enrollment.displayRELTOENROLL == 'Broker') {
            this.isNPNmandatory = true
        } else {
            this.isNPNmandatory = false
        }
    }
    // Individual End
    onBlur() {
        if (this.enrollment.ISSAMEADDRESS) this.clickOnSameAsBusinessAddress(true)
    }

    private getPlanList(planLst: PlanList[]) {
        this.optionrbPlan = planLst.map(this.buildPlanOption.bind(this))
    }

    private buildPlanOption(plan: PlanList): ValidatedRadioButtonModel {
        return {
            value: plan.PlanTypeShortName,
            htmlLabel: plan.PlanTypeName
        }
    }
}
